import { useSelector } from "react-redux"
import { IStoreState } from "../redux/initialStoreState"


export const useRecordCounts = () => {
    return useSelector((storeState: IStoreState)=> storeState.common.recordCounts);
}


export const useRecordCountsV2 = () => {
    return useSelector((storeState: IStoreState)=> storeState.common.recordCountsV2);
}